module.exports = __webpack_public_path__ + "img/ba_ro.06d17400.svg";